(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { ProfileManager } from '@kailona/core';

function mapToFHIRBloodPressure(vitalsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = vitalsData.date,
      systolicBloodPressure = vitalsData.systolicBloodPressure,
      diastolicBloodPressure = vitalsData.diastolicBloodPressure;

  if (!date || !systolicBloodPressure || !diastolicBloodPressure) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '85354-9',
        display: 'Blood pressure panel with all children optional'
      }],
      text: 'Blood pressure systolic & diastolic'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    component: [{
      code: {
        coding: [{
          system: 'http://loinc.org',
          code: '8480-6',
          display: 'Systolic blood pressure'
        }]
      },
      valueQuantity: {
        value: parseInt(systolicBloodPressure, 10),
        unit: 'mmHg',
        system: 'http://unitsofmeasure.org',
        code: 'mm[Hg]'
      }
    }, {
      code: {
        coding: [{
          system: 'http://loinc.org',
          code: '8462-4',
          display: 'Diastolic blood pressure'
        }]
      },
      valueQuantity: {
        value: parseInt(diastolicBloodPressure, 10),
        unit: 'mmHg',
        system: 'http://unitsofmeasure.org',
        code: 'mm[Hg]'
      }
    }]
  };
  var idMap = vitalsData.idMap;

  if (idMap && idMap.bloodPressure) {
    observation.id = idMap.bloodPressure;
  }

  return observation;
}

function mapToFHIRHeartRate(vitalsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = vitalsData.date,
      heartRate = vitalsData.heartRate;

  if (!date || !heartRate) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '8867-4',
        display: 'Heart rate'
      }],
      text: 'Heart rate'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseInt(heartRate, 10),
      unit: 'beats/minute',
      system: 'http://unitsofmeasure.org',
      code: '/min'
    }
  };
  var idMap = vitalsData.idMap;

  if (idMap && idMap.heartRate) {
    observation.id = idMap.heartRate;
  }

  return observation;
}

function mapToFHIROxygenSaturation(vitalsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = vitalsData.date,
      oxygenSaturation = vitalsData.oxygenSaturation;

  if (!date || !oxygenSaturation) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '2708-6',
        display: 'Oxygen saturation in Arterial blood'
      }],
      text: 'Oxygen saturation (SpO2)'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseInt(oxygenSaturation, 10),
      unit: '%',
      system: 'http://unitsofmeasure.org',
      code: '%'
    }
  };
  var idMap = vitalsData.idMap;

  if (idMap && idMap.oxygenSaturation) {
    observation.id = idMap.oxygenSaturation;
  }

  return observation;
}

function mapToFHIRBodyTemperature(vitalsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = vitalsData.date,
      bodyTemperature = vitalsData.bodyTemperature;

  if (!date || !bodyTemperature) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '8310-5',
        display: 'Body temperature'
      }],
      text: 'Body temperature'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(bodyTemperature),
      unit: '°C',
      system: 'http://unitsofmeasure.org',
      code: 'Cel'
    }
  };
  var idMap = vitalsData.idMap;

  if (idMap && idMap.bodyTemperature) {
    observation.id = idMap.bodyTemperature;
  }

  return observation;
}

function mapToFHIRVitalsPanel(vitalsData, observationIds) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = vitalsData.date;

  if (!date || !observationIds || !observationIds.length) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'vital-signs',
        display: 'Vital Signs'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '85353-1',
        display: 'Vital signs, weight, height, head circumference, oxygen saturation and BMI panel'
      }],
      text: 'Vital signs panel including blood pressure, heart rate and oxygen saturation'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    hasMember: observationIds.map(function (observationId) {
      return {
        reference: "Observation/".concat(observationId)
      };
    })
  };
  var idMap = vitalsData.idMap;

  if (idMap && idMap.panel) {
    observation.id = idMap.panel;
  }

  return observation;
}

export { mapToFHIRBloodPressure, mapToFHIRHeartRate, mapToFHIROxygenSaturation, mapToFHIRVitalsPanel, mapToFHIRBodyTemperature };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapToFHIRBloodPressure, "mapToFHIRBloodPressure", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRHeartRate, "mapToFHIRHeartRate", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIROxygenSaturation, "mapToFHIROxygenSaturation", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRBodyTemperature, "mapToFHIRBodyTemperature", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRVitalsPanel, "mapToFHIRVitalsPanel", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapToFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();